<section class="poi-panel" *ngIf="!hasVisiblePois  && (nearestPoiService.poi$ | async) as poi">
  <button
    [matTooltip]="poi.formattedName"
    class="go-to-button"
    type="button"
    (click)="handleGoTo(poi.coordinateLat, poi.coordinateLon)">
    <span>Go to</span>
    <svg
      [style.transform]="'rotate(' + poi.azimuth + 'deg)'"
      width="15" height="15" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.59998 11.99998L6.59999 2.29840L11.15702 6.85542L12 6L6 0L0 6L0.84300 6.85540L5.39999 2.29840L5.40002 12.00002L6.59998 11.99998Z" fill="#02A4FF"/>
    </svg>
  </button>

  <div class="poi-panel-info">
    <div class="title">{{ label }}</div>

    <div class="info">
      <span class="distance">{{poi.distanceMiles.toFixed(2)}} mi</span>
    </div>
  </div>
</section>
